import React from 'react';
import http from '@/services/http';
import { DELIVERY_URL } from './urls';

class DeliveryController extends React.Component {
	getAll = async cityId => {
		// console.log('getAllDeliveries', cityId)
		let data;

		try {
			const res = await http.get(`${DELIVERY_URL}${cityId || ''}`);
			// console.log(res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			deliveries: data.deliveries,
		};
	};

	add = async (delivery, cityId) => {
		// console.log("addDelivery", cityId);
		let data;

		try {
			const res = await http.post(`${DELIVERY_URL}${cityId || ''}`, {
				delivery,
			});
			// console.log("res from add", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	edit = async (deliveryId, delivery) => {
		// console.log("editDelivery");
		let data;

		try {
			const res = await http.put(`${DELIVERY_URL}${deliveryId}`, { delivery });
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	delete = async deliveryId => {
		// console.log("deleteDelivery");
		let data;

		try {
			const res = await http.delete(`${DELIVERY_URL}${deliveryId}`);
			// console.log("res from deleteDelivery", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};
}

const deliveryController = new DeliveryController();

export default deliveryController;
